// attach handlers
export default function on(element, event, handler, options) {
  const ops = options || false;
  element.addEventListener(event, handler, ops);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/event/on.js
// module id = 3
// module chunks = 0